import {Vue} from "@/mixins/combinations";

class Settings {
	private readonly storageKey = "settings"
	private state = Vue.observable({showHiddenLanguages: false})

	public get showHiddenLanguages(): boolean {
		return this.state.showHiddenLanguages
	}
	public set showHiddenLanguages(value: boolean) {
		this.state.showHiddenLanguages = value
		this.save()
	}

	constructor() {
		this.load()
	}

	private save(): void {
		window.localStorage.setItem(this.storageKey, JSON.stringify(this.state))
	}

	private load(): void {
		const data = window.localStorage.getItem(this.storageKey)
		if (data === null)
			return

		const parsed = JSON.parse(data)

		if (Object.hasOwn(parsed, "showHiddenLanguages"))
			this.showHiddenLanguages = parsed.showHiddenLanguages
	}
}

export default new Settings()
